// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2WT8W","dragIcon":"Choice_dragIcon__2MZbV","left":"Choice_left__1wYid","input":"Choice_input__8BI9O"};